import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button, Table } from "antd";
import axios from "axios";
import moment from "moment";
import { Api_Url } from "../../../config/config";
import Breadcrumbs from "../../../components/Breadcrumbs";
import BuisnessPDFilter from "./BuisnessPDFilter";
import SearchBox from "../../../components/SearchBox";
import { BuisnessPDModalPopup } from "./BuisnessPDModalPopup";
import DeleteModal from "../../../components/modelpopup/DeleteModal";
import "./BuisnessPd.css";
import { ErrorToast, SuccessToast } from "../../ToastComponent";

const BuisnessPDList = () => {


  const UserRole = JSON.parse(sessionStorage.getItem('role'))

  const [data, setData] = useState([]);

  const handleFilterBuisnessPdFunc = (selected) => {
    setData(selected);
  };

  const BuisnessPDListFetchFunc = async () => {
    const id = JSON.parse(sessionStorage.getItem("user"))?.id;
    const response = await axios.get(
      `${Api_Url}api/v1/BusinessPd/getbyuserid/${id}`,
      {
        headers: {
          Authorization: `Bearer ${
            JSON.parse(sessionStorage.getItem("user"))?.accessToken
          }`,
        },
      }
    );
    console.log(response.data.length)
    setData(response.data);
  };

  useEffect(() => {
    BuisnessPDListFetchFunc();
  }, []);

  // console.log("first", data);

  const navigate = useNavigate();

  // Download Button

  const handleDownload = async (id) => {
    try {
      const response = await axios.get(
        `${Api_Url}api/v1/BusinessPd/generatebusinesspdpdf/${id}`,
        {
          responseType: "blob", // Important to handle binary data correctly
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user"))?.accessToken
            }`,
          },
        }
      );

      // Create a blob object from the response
      const file = new Blob([response.data], { type: "application/pdf" });

      // Create a URL for the blob object
      const fileURL = URL.createObjectURL(file);

      // Create a link element
      const link = document.createElement("a");
      link.href = fileURL;
      link.setAttribute("download", `BusinessPD-${id}.pdf`); // Specify the file name

      // Append the link to the body
      document.body.appendChild(link);

      // Trigger the download
      link.click();

      // Clean up
      URL.revokeObjectURL(fileURL);
      document.body.removeChild(link);

      SuccessToast("Download Successful");
    } catch (error) {
      ErrorToast("Something went wrong");
    }
  };

  const columns = [
    {
      title: "Customer Name",
      dataIndex: "name",
    },
    {
      title: "Branch Name",
      dataIndex: "branchName",
    },
    {
      title: "Application Number",
      dataIndex: "applicationNo",
    },
    {
      title: "Mobile",
      dataIndex: "mobile",
    },
    {
      title: "Created",
      dataIndex: "",
      render: (text, record) => (
        <span className="table-avatar">
          {moment(record.created).format("MMMM Do YYYY, h:mm:ss a")}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "status",
      sorter: (a, b) => a.status.length - b.status.length,
    },
    {
      title: "Download",
      dataIndex: "id", // Use dataIndex to access record.id
      render: (id) => (
        <Button onClick={() => handleDownload(id)}>
          <i className="fa-solid fa-download"></i>
        </Button>
      ),
    },

    // render: (text, record) => (
    //   <Button
    //     // to={`expenses/${record.id}`}
    //     onClick={() => {
    //       navigate(`expenses/${record.id}`, {
    //         // state: { ...record},
    //         state: { profileId, ProfileId },
    //         //  state:{}
    //       });
    //     }}
    //   >View Expense</Button>
    // ),

    {
      title: "View",
      dataIndex: "actions",
      render: (text, record) => (
        <Button className="btn-property"
          onClick={() => {
            navigate(`details/${record.id}`, {
              state: { record },
            });
          }}>
            <i className="fa-solid fa-eye"></i>
            </Button>
      ),
    },
  ];

  const rowClassName = (record) => {
    return record.isMismatched ? "table-row-red" : "";
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content container-fluid">

        <div className="page-header">
            <div className="row align-items-center">
              <div className="col-md-4">
                <h3 className="page-title">Buisness PD</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Buisness PD</li>
                </ul>
              </div>
              <div className="col-md-8 float-end ms-auto">
                <div className="d-flex title-head">
                  <div className="view-icons">
                  </div>
                  {UserRole == "Credit" ? (
                    <Breadcrumbs
                    modal="#add_client"
                    name="Add Business PD"
                    Linkname="/clients"
                    Linkname1="/clients-list"
                    addModalLink="add"
                  />
                  ): null}
                </div>
              </div>
            </div>
          </div>


          {/* <Breadcrumbs
            maintitle="PD"
            title="Credit"
            subtitle="Business PD"
            modal="#add_client"
            name="Add Business PD"
            Linkname="/clients"
            Linkname1="/clients-list"
            addModalLink="add"
          /> */}
          {UserRole == "Credit" ? (<BuisnessPDFilter
            handleFilterBuisnessPdFunc={handleFilterBuisnessPdFunc}
          />) : null}
          <div className="row">
            <div className="col-md-12">
              <div className="table-responsive">
                <SearchBox />
                <Table
                  className="table-striped"
                  style={{ overflowX: "auto", color: "green" }}
                  columns={columns}
                  dataSource={data}
                  rowKey={(record) => record.id}
                  rowClassName={rowClassName}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <BuisnessPDModalPopup />
      <DeleteModal Name="Delete Client" />
    </>
  );
};

export default BuisnessPDList;
